import type { CampaignSelectDto } from '@@types/api.types';
import { ClassificationBadge } from '@components/shared/classification-badge.component';
import { StudyStatusBadge } from '@components/shared/study-status-badge.component';
import { Tile } from '@components/shared/tile.component';
import { Badge } from '@components/ui/badge';
import { EditIcon } from 'lucide-react';
import type { FC } from 'react';

type CampaignConsumedStudiesTileProps = {
  campaign: CampaignSelectDto;
  onEdit: () => void;
};

export const CampaignConsumedStudiesTile: FC<CampaignConsumedStudiesTileProps> = (props) => {
  const { campaign, onEdit } = props;
  const studies = campaign.consumedStudies;
  const isEmpty = studies.length === 0;

  return (
    <Tile
      emptyState={{
        message: '+ Add Study',
        onClick: onEdit,
        title: 'No Studies',
      }}
      header={{
        iconButton: { ariaLabel: 'Edit consumed studies', icon: <EditIcon />, onClick: onEdit },
        title: 'Consumed Studies',
      }}
      hoverReveal
      isEmpty={isEmpty}
    >
      <div className="flex flex-col gap-2">
        {studies.map((link) => (
          <div
            className="flex flex-col gap-1 rounded-md border border-gray-200 px-3 py-2"
            key={link.id}
          >
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-sm font-medium text-gray-800">{link.studyName ?? link.studyId}</span>
              {link.studyClassificationLevel && <ClassificationBadge classification={link.studyClassificationLevel} />}
              {link.studyStatus && <StudyStatusBadge status={link.studyStatus} />}
              {link.studyCurrentGate && (
                <Badge
                  size="xs"
                  variant="secondary"
                >
                  {link.studyCurrentGate}
                </Badge>
              )}
            </div>
          </div>
        ))}
      </div>
    </Tile>
  );
};
